import { MutableRefObject, RefObject } from "react";
import { PopoverPositionType } from "./Popover";
import { DirectionType } from "./usePopover";

type Position = {
    top: number,
    left: number,
    width?: number,
    height?: number
}

function calculateScrollBarWidth(parent?: HTMLElement) {
    let x = 0;
    let y = 0;

    if (document.body.scrollWidth > window.innerWidth) {
        y = window.innerHeight - document.documentElement.clientHeight;
    }

    if (document.body.scrollHeight > window.innerHeight) {
        x = window.innerWidth - document.documentElement.clientWidth;
    }

    if (parent) {
        if (parent.scrollWidth > parent.clientWidth && parent.offsetWidth > parent.clientWidth) {
            y = parent.offsetHeight - parent.clientHeight;
        }

        if (parent.scrollHeight > parent.clientHeight && parent.offsetHeight > parent.clientHeight) {
            x = parent.offsetWidth - parent.clientWidth;
        }
    }

    const scrollbar = {
        scrollbarXwidth: x < 0 ? 0 : x,
        scrollbarYwidth: y < 0 ? 0 : y
    };

    return scrollbar;
}

export function getSecondLast<T>(array: T[]) {
    if (array.length < 2) {
        return undefined;
    }

    return array[array.length - 2];
}

export const updateBasePosition = (anchorRef: MutableRefObject<HTMLElement>, actualPosition: PopoverPositionType) => {

    const rect = (anchorRef.current).getBoundingClientRect();
    
    let pos: any = {
        top: rect.top + rect.height,
        left: rect.left
    };

    // const direction = actualPosition.split('-')[0];

    if (actualPosition === 'top-left') {
        pos = {
            bottom: rect.top,
            left: rect.left
        }
    }
    else if (actualPosition === 'top-center') {
        pos = {
            bottom: rect.top,
        }
    }
    else if (actualPosition === 'top-right') {
        pos = {
            bottom: rect.top,
            right: rect.right
        }
    }
    else if (actualPosition === 'bottom-left') {
        pos = {
            left: rect.left,
            top: rect.bottom
        }
    }
    else if (actualPosition === 'bottom-right') {
        pos = {
            right: rect.right,
            top: rect.bottom
        }
    }
    else if (actualPosition === 'bottom-center') {
        pos = {
            top: rect.bottom,
        }
    }
    else if (actualPosition === 'right-top') {
        pos = {
            left: rect.right,
            bottom: rect.bottom
        }
    }
    else if (actualPosition === 'right-bottom') {
        pos = {
            left: rect.right,
            top: rect.top
        }
    }
    else if (actualPosition === 'right-center') {
        pos = {
            left: rect.right,
        }
    }
    else if (actualPosition === 'left-top') {
        pos = {
            right: rect.left,
            bottom: rect.bottom
        }
    }
    else if (actualPosition === 'left-bottom') {
        pos = {
            right: rect.left,
            top: rect.top
        }
    }
    else if (actualPosition === 'left-center') {
        pos = {
            right: rect.left,
        }
    }

    return pos;
}

const updateOffset = (param: number): number => {
    const offset = 8;
    return param + offset
}

const getViewPort = (parent?: HTMLElement) => {

    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    let width = windowWidth;
    let height = windowHeight;
    let top = 0;
    let left = 0;
    let right = 0;
    let bottom = 0;

    const { scrollbarXwidth, scrollbarYwidth } = calculateScrollBarWidth(parent);

    if (parent) {
        const parentrect = parent.getBoundingClientRect();

        height = parentrect.bottom - parentrect.top;
        width = parentrect.right - parentrect.left;
        top = parentrect.top;
        left = parentrect.left;
        right = parentrect.right;
        bottom = parentrect.bottom;
        //If window height is less than inner container height then window height will be taken
        if (parent.scrollWidth == parent.clientWidth) {
            width = windowWidth;
            left = 0;
            right = windowWidth;
        }
        //If window width is less than inner container width then window width will be taken
        if (parent.scrollHeight == parent.clientHeight) {
            height = windowHeight;
            top = 0;
            bottom = windowHeight
        }
    } else {
        right = width - scrollbarXwidth;
        bottom = height - scrollbarYwidth;
    }

    height = height - scrollbarYwidth;
    width = width - scrollbarXwidth;

    return {
        height, width, top, left, right, bottom, windowHeight, windowWidth
    };
}

type PP = "bottom" | "left" | "right" | "top";

const allDirections = ['left', 'top', 'right', 'bottom'];

const generateRightPositon = (actualDirection: PP) => {
    let possiblePositions: PopoverPositionType[] = [];

    if (actualDirection === 'top') {
        possiblePositions = ['top-center', 'top-right', 'top-left', 'left-top', 'left-center', 'left-bottom', 'right-top', 'right-center', 'right-bottom', 'bottom-left', 'bottom-center', 'bottom-right']
    }
    else if (actualDirection === 'bottom') {
        possiblePositions = ['bottom-center', 'bottom-left', 'bottom-right', 'left-bottom', 'left-center', 'left-top', 'right-bottom', 'right-center', 'right-top', 'top-left', 'top-center', 'top-right']
    }
    else if (actualDirection === 'left') {
        possiblePositions = ['left-center', 'left-bottom', 'left-top', 'bottom-right', 'bottom-center', 'bottom-left', 'right-bottom', 'right-center', 'right-top', 'top-center', 'top-left', 'top-right']
    }
    else if (actualDirection === 'right') {
        possiblePositions = ['right-center', 'right-bottom', 'right-top', 'top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right', 'left-top', 'left-center', 'left-bottom']
    }

    return possiblePositions;
}

export const LoopThroughThePositions = (actualPosition: PopoverPositionType, ap: PopoverPositionType[], prefferedPopoverPosition: PopoverPositionType) => {
    const actualDirection = actualPosition.split('-')[0] as PP;
    const pp = generateRightPositon(actualDirection);
    for (let i = 0; i < pp.length; i++) {
        if (ap.includes(pp[i])) {
            return pp[i];
        }
    }

    return prefferedPopoverPosition;
}

export const isElementOutofView = (element: HTMLElement, parent?: HTMLElement) => {
    if (!element) return false;
    const anchorRect = element.getBoundingClientRect();
    const viewport = getViewPort(parent);
    const outOfViewport = (anchorRect.top < viewport.top && anchorRect.bottom < viewport.top)
        || (anchorRect.left < viewport.left && anchorRect.right < viewport.left)
        || (anchorRect.right > viewport.right && anchorRect.left > viewport.right)
        || (anchorRect.bottom > viewport.bottom && anchorRect.top > viewport.bottom);

    return outOfViewport;
}

export const isColidingWithViewPort = (element: HTMLElement, parent?: HTMLElement,) => {
    // get element boundrary
    const elementRect = element.getBoundingClientRect();

    if (elementRect.width === 0) return { isColliding: false, details: {} }


    const viewport = getViewPort(parent);

    const top = elementRect.top < viewport.top;
    const bottom = elementRect.bottom > viewport.bottom;
    const left = elementRect.left < viewport.left;
    const right = elementRect.right > viewport.right;

    const colideObject = {
        top,
        bottom,
        left,
        right
    };

    return {
        isColliding: (colideObject.bottom || colideObject.top || colideObject.left || colideObject.right),
        details: colideObject
    }

}

export const getBasePosition = (anchor: HTMLElement, position: PopoverPositionType, offset = 8) => {
    const rect = (anchor as unknown as HTMLElement).getBoundingClientRect();

    let pos: any = {
        top: rect.top + rect.height,
        left: rect.left
    };

    const direction = position.split('-')[0];

    if (direction === 'top') {
        pos = {
            bottom: rect.top - offset,
            left: rect.left
        }
    }
    else if (direction === 'right') {
        pos = {
            left: rect.right + offset,
            top: rect.top
        }
    }
    else if (direction === 'left') {
        pos = {
            right: rect.left - offset,
            top: rect.top
        }
    }
    else if (direction === 'bottom') {
        pos = {
            left: rect.left,
            top: rect.bottom + offset
        }
    }

    return pos;

}

export const getPositonsOnDirection = (anchor: HTMLElement, popover: HTMLElement, parent?: HTMLElement) => {
    const wd = getViewPort(parent);
    if (!(popover || anchor)) return null;

    const targetRect = anchor.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();

    const popoverHalfHeight = popoverRect.height / 2;
    const targetHalfHeight = targetRect.height / 2;
    const targetHalfWidth = targetRect.width / 2;
    const popoverHalfWidth = popoverRect.width / 2;

    // find the center line of the target/anchor element
    const targetCenterY = (targetRect.top + targetHalfHeight);
    const targetCenterX = (targetRect.left + targetHalfWidth);

    // Calculate the space available in both horizantally and vertically from the center line
    const spaceInRigthSideFormCenter = wd.right - targetCenterX;
    const spaceInBottomSideFromCenter = wd.bottom - targetCenterY;

    if (popoverRect.width === 0) return null;

    const popoverOffsetHeight = updateOffset(popoverRect.height);
    const popoverOffsetWidth = updateOffset(popoverRect.width);

    // Calculate space all sides
    const rightSideSpace = wd.right - targetRect.right;
    const leftSideSpace = targetRect.left - wd.left;
    const bottomSideSpace = wd.bottom - targetRect.bottom;
    const topSideSpace = targetRect.top - wd.top;

    const directions: DirectionType = { top: [], left: [], right: [], bottom: [] }

    const checkHorizantal = (d: PP) => {
        const pos: PopoverPositionType[] = [];

        // Check space right from the left edge of the target element
        const spaceRightFromLeftEdgeOfTarget = wd.right - targetRect.left;
        if (spaceRightFromLeftEdgeOfTarget > popoverRect.width && targetRect.left > wd.left) {
            pos.push(`${d}-left` as PopoverPositionType);
        }
        if ((targetCenterX - wd.left) > popoverHalfWidth && spaceInRigthSideFormCenter > popoverHalfWidth) {
            pos.push(`${d}-center` as PopoverPositionType);
        }

        const spaceRightFromRightEdgeOfTarget = targetRect.right - wd.left;
        if (spaceRightFromRightEdgeOfTarget > popoverRect.width && targetRect.right < wd.right) {
            pos.push(`${d}-right` as PopoverPositionType);
        }

        return pos;
    }

    const checkVertical = (d: PP) => {
        const pos: PopoverPositionType[] = [];
        if (targetRect.bottom > popoverOffsetHeight && targetRect.bottom < wd.bottom) {
            pos.push(`${d}-top` as PopoverPositionType);
        }
        if (((targetCenterY - wd.top) > popoverHalfHeight && spaceInBottomSideFromCenter > popoverHalfHeight)) {
            pos.push(`${d}-center` as PopoverPositionType);
        }
        const verticalSpace = (wd.height - targetRect.top);

        if (verticalSpace > popoverOffsetHeight && (targetRect.top > wd.top)) {
            pos.push(`${d}-bottom` as PopoverPositionType);
        }

        return pos;
    }

    let avalilablePositions: PopoverPositionType[] = [];


    allDirections.forEach(direction => {
        if (direction === 'top' && topSideSpace > popoverOffsetHeight) {
            directions['top'] = checkHorizantal('top');
            avalilablePositions = [...avalilablePositions, ...directions['top']]
        }
        else if (direction === 'left' && leftSideSpace > popoverOffsetWidth) {
            directions['left'] = checkVertical(direction);
            avalilablePositions = [...avalilablePositions, ...directions['left']]
        }
        else if (direction === 'bottom' && bottomSideSpace > popoverOffsetHeight) {
            directions['bottom'] = checkHorizantal('bottom');
            avalilablePositions = [...avalilablePositions, ...directions['bottom']]
        }
        else if (direction === 'right' && rightSideSpace > popoverOffsetWidth) {
            directions['right'] = checkVertical(direction);
            avalilablePositions = [...avalilablePositions, ...directions['right']]
        }
    });


    return { directions, avalilablePositions };
}

function updatePosition(targetRef: RefObject<HTMLElement>,
    popoverRef: RefObject<HTMLElement>,
    popoverPosition: PopoverPositionType,
    offset = 8): Position | null {

    if (targetRef.current && popoverRef.current) {
        const targetRect = targetRef.current.getBoundingClientRect();
        const popoverRect = popoverRef.current.getBoundingClientRect();

        const position: Position = {
            top: targetRect.top + window.scrollY,
            left: targetRect.left + window.scrollX
        }

        if (popoverPosition === "left-bottom") {
            position.left = position.left - popoverRect.width - offset;
        }
        else if (popoverPosition === "left-top") {
            position.top = position.top + targetRect.height - popoverRect.height;
            position.left = position.left - popoverRect.width - offset;
        }
        else if (popoverPosition === "left-center") {
            position.top = position.top - ((popoverRect.height / 2) - (targetRect.height / 2));
            position.left = position.left - popoverRect.width - offset;
        }
        else if (popoverPosition === "right-bottom") {
            position.left = position.left + targetRect.width + offset;
        }
        else if (popoverPosition === "right-top") {
            position.top = position.top + targetRect.height - popoverRect.height;
            position.left = position.left + targetRect.width + offset;
        }
        else if (popoverPosition === "right-center") {
            position.top = position.top - ((popoverRect.height / 2) - (targetRect.height / 2));
            position.left = position.left + targetRect.width + offset;
        }
        else if (popoverPosition === "bottom-left") {
            position.top = position.top + targetRect.height + offset;
        }
        else if (popoverPosition === "bottom-right") {
            position.top = position.top + targetRect.height + offset;
            position.left = position.left - (popoverRect.width - targetRect.width);
        }
        else if (popoverPosition === "bottom-center") {
            position.top = position.top + targetRect.height + offset;
            position.left = position.left - targetRect.width / 2 - popoverRect.width / 2 + targetRect.width;
        }
        else if (popoverPosition === "top-left") {
            position.top = position.top - popoverRect.height - offset;
        }
        else if (popoverPosition === "top-center") {
            position.top = position.top - popoverRect.height - offset;
            position.left = position.left - targetRect.width / 2 - popoverRect.width / 2 + targetRect.width;
        }
        else if (popoverPosition === "top-right") {
            position.top = position.top - popoverRect.height - offset;
            position.left = position.left - (popoverRect.width - targetRect.width);
        }

        return position;
    }

    return null;
}

export default updatePosition;